// The fragments project-overview's two status-history activity charts share (location, teams) —
// level tables on `defineHierarchyChart` (@rdrive/helper-chart-config; IA_ABSORPTION_PLAN Phase 5
// steps 5.2–5.4). Domain SQL, so it stays app-side (rule 2).
//
// The providers always read `filteredStatusHistory` — they ignore the base's `filtered` flag, as
// they always did; the filters select the status_history_temporal key tuple. Scoping: none — no
// drill scope; a level filters by its own id plus, where it needs one, the parent id that arrives as
// the base's second positional contextUpdater argument, so no closure drill state is needed.
export const STATUS_HISTORY_CHART = {
  source: { table: 'filteredStatusHistory', alias: 'sh' },
  status: { join: 'JOIN status_templates s ON sh.statusId = s.id' },
  filter: { table: 'status_history_temporal', keys: 'sh.subItemId, sh.validFrom, sh.statusId' },
};

// The terminal level. No filter on purpose: the base treats a missing terminal updater as
// "clicking here does nothing".
export const SINGLE_STATUS_LEVEL = {
  level: 'singlestatus', titleKey: 'singlestatus',
  id: 's.id', title: 's.title',
  groupBy: 's.id, s.title, s.color, s.sort', orderBy: 's.sort, s.title',
};
